
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/synapse",
      function () {
        return require("private-next-pages/sources/synapse.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/synapse"])
      });
    }
  